export default "__VITE_ASSET__8OB$F9wp__"